var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilterVector(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.052,
    height: 20.149,
    viewBox: "0 0 19.052 20.149",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_206-user-6",
    "data-name": "206-user-6",
    transform: "translate(1.024)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M83.059,9.274a4.637,4.637,0,1,0-4.637-4.637A4.637,4.637,0,0,0,83.059,9.274Zm0-8.4a3.759,3.759,0,1,1-3.76,3.76A3.76,3.76,0,0,1,83.059.877Zm0,0",
    transform: "translate(-76.656)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    d: "M17.59,281.562h-7.9a.44.44,0,0,0-.439.439v.553a7.449,7.449,0,0,0-2.843-.562H6.4A7.281,7.281,0,0,0,1.143,284.2a7.792,7.792,0,0,0-2.167,5.523.44.44,0,0,0,.439.439l12.924-.022v1.246a.439.439,0,0,0,.206.373.433.433,0,0,0,.232.066.4.4,0,0,0,.2-.048l1.729-.864a.439.439,0,0,0,.241-.39v-2.856l2.93-2.514a.444.444,0,0,0,.154-.333V282a.438.438,0,0,0-.439-.439Zm-.439.877v.461H10.132v-.461ZM-.133,289.279a6.86,6.86,0,0,1,1.9-4.47A6.4,6.4,0,0,1,6.4,282.87h.013a6.552,6.552,0,0,1,2.843.645v1.3a.443.443,0,0,0,.154.333l2.93,2.514v1.6Zm14.354-2.15a.443.443,0,0,0-.154.333v2.786l-.851.426v-3.211a.443.443,0,0,0-.154-.333l-2.93-2.514v-.842h7.019v.842Zm0,0",
    transform: "translate(0 -271.674)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterVector);
export default __webpack_public_path__ + "static/media/FilterVector.a7653ac5d6561abe62355087061fa544.svg";
export { ForwardRef as ReactComponent };